import { render, staticRenderFns } from "./CircularProgressLoader.vue?vue&type=template&id=3b87c9c1&scoped=true"
import script from "./CircularProgressLoader.vue?vue&type=script&lang=ts"
export * from "./CircularProgressLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b87c9c1",
  null
  
)

export default component.exports